import React from "react";
import _ from "lodash";
import moment from "moment-timezone";
import ReactTooltip from "react-tooltip";
import ExperimentGroups from "./ExperimentGroups";

class ExperimentDetail extends React.Component {
  constructor(props) {
    super(props);

    this.handleGoToExp = this.handleGoToExp.bind(this);
  }

  handleGoToExp(expId) {
    if (!expId) return;
    this.props.goToExp(expId);
  }

  render() {
    const { data, expId, expLink } = this.props;
    const { groupInfo, expInfo } = data;

    const exp = _.find(data.yieldLifts, { expId: expId });

    const reports = exp.reports;

    return (
      <>
        {/* Experiment Title */}
        <div className="rounded-t sticky top-0 bg-gray-400 px-4 pb-2">
          <div className="flex justify-between pt-4 pb-2 font-mono">
            <div>
              EXP-{exp.expId}{" "}
              <span
                className="border-b border-dashed border-gray-600"
                data-tip
                data-for={`parameters-${exp.expId}`}
              >
                {expInfo[exp.expId].name}
              </span>
              <ReactTooltip
                id={`parameters-${exp.expId}`}
                type="dark"
                effect="solid"
              >
                <div>
                  <pre>
                    {JSON.stringify(expInfo[exp.expId].parameters, null, 2)}
                  </pre>
                </div>
              </ReactTooltip>
            </div>
            <button
              type="button"
              className="underline"
              onClick={this.props.close}
            >
              Close
            </button>
          </div>

          <div className="flex justify-between">
            <div className="flex justify-between text-2xl font-bold text-gray-900">
              <span className="mr-2">
                {moment(exp.startDate)
                  .tz("Asia/Taipei")
                  .format("YYYY-MM-DD HH:mm Z")}{" "}
                GMT+8
              </span>
              <span className="mx-2 text-gray-600">·</span>
              <span className="mx-2">Mode: {expInfo[exp.expId].mode}</span>
              <span className="mx-2 text-gray-600">·</span>

              {exp.grossLift && (
                <div>
                  GrossLift: {exp.grossLift}%
                  <span className="mx-2 text-gray-600">·</span>
                  NetLift: {exp.netLift}%
                </div>
              )}
            </div>
            <div className="inline-flex">
              <button
                type="button"
                onClick={() => this.handleGoToExp(expLink[exp.expId].prev)}
                className={`rounded py-2 px-4 font-bold text-white ${
                  expLink[exp.expId].prev
                    ? "bg-blue-500 hover:bg-blue-700"
                    : "bg-gray-500"
                }`}
              >
                Previous
              </button>

              <button
                type="button"
                onClick={() => this.handleGoToExp(expLink[exp.expId].next)}
                className={`rounded ml-1 py-2 px-4 font-bold text-white ${
                  expLink[exp.expId].next
                    ? "bg-blue-500 hover:bg-blue-700"
                    : "bg-gray-500"
                }`}
              >
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Experiment Groups */}
        <div className="bg-gray-200 px-4">
          <ExperimentGroups
            reports={reports}
            groupInfo={groupInfo}
            expId={exp.expId}
          ></ExperimentGroups>
        </div>
      </>
    );
  }
}

export default ExperimentDetail;
